// @flow
import { css } from "styled-components";
import { media, ResponsiveImage } from "@nested/brand";
import {
  fadeIn,
  QuestionWrapper,
  type Props as QuestionWrapperProps,
} from "./QuestionWrapper";

const wrapperStyle = css`
  display: flex;
  flex-direction: column;

  ${media.desktop`
    margin: auto;
    flex-direction: row;
    align-items: center;
    width: 100%;
    max-width: 880px;
  `};
`;
const questionWrapperStyles = css`
  ${media.desktop`
    max-width: 400px;
    flex-grow: 0;
    margin-left: 0;
  `}
`;

const imageWrapperStyle = css`
  display: none;
  ${media.desktop`
    display: block;
    padding: 0 20px;
    max-width: 440px;
    flex-grow: 0;
    animation: 0.7s ${fadeIn} ease;
    box-sizing: border-box;
  `}
`;

const imageStyle = css`
  ${media.desktop`
    width: 100%;
  `}
`;

type Props = {|
  ...QuestionWrapperProps,
  imageUrl: string,
|};

export const QuestionAndImageWrapper = ({ imageUrl, ...rest }: Props) => {
  return (
    <div css={wrapperStyle}>
      <QuestionWrapper css={questionWrapperStyles} {...rest}></QuestionWrapper>
      <div css={imageWrapperStyle}>
        <ResponsiveImage width="400" css={imageStyle} alt="" src={imageUrl} />
      </div>
    </div>
  );
};
